import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const DownstreamDashboardsFilteredByFieldQueryGql: DocumentNode = gql`
query DownstreamDashboardsFilteredByFieldQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DashboardsDisplayGridRowDataFragment
        }
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
